import { useEffect, useState } from 'react';
import { PaymentStatusClient } from '../services/apiClient'; 
import { API_BASE_URL } from '../config/config';
import axiosInstance from "../services/axiosInstance";

const usePaymentStatus = () => {
    const [paymentStatuses, setPaymentStatuses] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const client = new PaymentStatusClient(API_BASE_URL, axiosInstance);

    useEffect(() => {
        const fetchPaymentStatuses = async () => {
            setIsLoading(true);
            try {
                const lists = await client.getPaymentStatuss();
                if (lists && lists.success && lists.data) {
                    setPaymentStatuses(lists.data);
                } else {
                    setError('Failed to fetch payment statuses');
                }
            } catch (err) {
                setError('Error fetching payment statuses');
                console.error('Error fetching payment statuses:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPaymentStatuses();
    }, []);

    return { paymentStatuses, isLoading, error };
};

export default usePaymentStatus;
